<div class="flex flex-col gap-2.5 p-4">
  <div class="text-base font-semibold text-center mb-4">
    Highlighted Network Measurements
  </div>

  <!-- <div
    class="flex justify-between items-center py-3 px-4 rounded-lg text-base"
    [ngClass]="{
      'bg-yellow-500 text-blue-950': category === 'warning',
      'bg-orange-600 text-white': category === 'critical',
      'bg-green-500 text-blue-950':
        category !== 'warning' && category !== 'critical',
    }"
  >
    <span class="pr-2.5">Data Utilization:</span>
    <span class="font-semibold">{{ dataUtilization }}%</span>
  </div> -->

  <div
    class="flex justify-between items-center py-5 px-4 rounded-lg text-base"
    [ngClass]="{
      'bg-orange-500 text-blue-950': category === 'warning',
      'bg-orange-600 text-white': category === 'critical',
      'bg-green-500 text-blue-950':
        category !== 'warning' && category !== 'critical',
    }"
  >
    <span class="pr-2.5">Latency:</span>
    <span class="font-semibold">{{ latency }}ms</span>
  </div>

  <div
    class="flex justify-between items-center py-5 px-4 rounded-lg text-base"
    [ngClass]="{
      'bg-orange-500 text-blue-950': category === 'warning',
      'bg-orange-600 text-white': category === 'critical',
      'bg-green-500 text-blue-950':
        category !== 'warning' && category !== 'critical',
    }"
  >
    <span class="pr-2.5">Jitter:</span>
    <span class="font-semibold">{{ jitter }}ms</span>
  </div>

  <div
    class="flex justify-between items-center py-5 px-4 rounded-lg text-base"
    [ngClass]="{
      'bg-orange-500 text-blue-950': category === 'warning',
      'bg-orange-600 text-white': category === 'critical',
      'bg-green-500 text-blue-950':
        category !== 'warning' && category !== 'critical',
    }"
  >
    <span class="pr-2.5">Packet Loss:</span>
    <span class="font-semibold">{{ packetLost }}%</span>
  </div>
</div>
